/**
 * Partner-friendly labels for upload_failed rows in analytics.
 */
const TYPE_LABELS = {
  INVALID_FILE_TYPE: "Incorrect file type — try a JPG or PNG",
  INVALID_TYPE: "Incorrect file type — try a JPG or PNG",
  UNSUPPORTED_MEDIA_TYPE: "Incorrect file type — try a JPG or PNG",
  MULTI_PAGE_PDF: "Multi-page PDFs aren't supported",
  NO_FILE: "No file was selected",
  FILE_TOO_LARGE: "File is too large (max 10 MB)",
  PLAN_SIZE_UNSUPPORTED: "File is too large (max 10 MB)",
  PAYLOAD_TOO_LARGE: "File is too large (max 10 MB)",
  NO_DIMENSIONS: "No readable dimension markings",
  MIXED_SCALE: "Couldn't determine plan scale",
  SIZE_UNSUPPORTED: "Couldn't determine plan scale",
  NO_USABLE_ROOMS: "No usable rooms detected on plan",
  NOT_A_FLOOR_PLAN: "Couldn't analyze this plan",
  FURNITURE_DETECTED: "Plan already shows furniture",
  FILE_UNREADABLE: "File couldn't be read — try a clearer image",
  INVALID_PDF: "PDFs aren't supported",
  NETWORK_ERROR: "Connection problem — check your network",
  TIMEOUT_ERROR: "Timed out — please try again",
  POLLING_TIMEOUT: "Processing took too long — try again",
  JOB_FAILED: "Something went wrong while processing",
  SERVICE_UNAVAILABLE:
    "Processing is temporarily unavailable — please try again later",
  RATE_LIMIT: "Too many attempts — wait and try again",
  FORBIDDEN: "Upload not allowed",
  SERVER_ERROR: "Something went wrong on our end",
  VALIDATION_ERROR: "Couldn't process this floor plan",
  AUTH_ERROR: "Sign-in required",
  UNKNOWN_ERROR: "Couldn't process this floor plan",
};

const messageHeuristic = (message) => {
  const m = (message || "").toLowerCase();
  if (!m) return null;

  if (
    m.includes("unsupported format") ||
    m.includes("invalid file type") ||
    m.includes("jpg") ||
    m.includes("png") ||
    (m.includes("pdf") && (m.includes("unsupported") || m.includes("invalid type")))
  ) {
    return "Incorrect file type — try a JPG or PNG";
  }
  if (m.includes("pdf") && (m.includes("more than 1 page") || m.includes("multiple page"))) {
    return "Multi-page PDFs aren't supported";
  }
  if (m.includes("pdf") && !m.includes("unreadable") && !m.includes("corrupt")) {
    return "PDFs aren't supported";
  }
  if (
    m.includes("scale inference") ||
    m.includes("scale validation") ||
    m.includes("mixed scale") ||
    m.includes("size_unsupported") ||
    m.includes("uniform scale") ||
    (m.includes("scale") && !m.includes("dimension"))
  ) {
    return "Couldn't determine plan scale";
  }
  if (m.includes("add visible dimensions") || m.includes("dimension markings")) {
    return "No readable dimension markings";
  }
  if (m.includes("no usable rooms") || m.includes("no rooms suitable")) {
    return "No usable rooms detected on plan";
  }
  if (m.includes("temporarily unavailable") || m.includes("try again in a few minutes")) {
    return "Processing is temporarily unavailable — please try again later";
  }
  if (m.includes("too large") || m.includes("10 mb") || m.includes("file size")) {
    return "File is too large (max 10 MB)";
  }
  if (m.includes("furniture")) {
    return "Plan already shows furniture";
  }
  if (
    m.includes("not a floor plan") ||
    m.includes("not detected as a floor plan") ||
    m.includes("does not appear to be a floor plan") ||
    m.includes("please upload a valid floor plan")
  ) {
    return "Couldn't analyze this plan";
  }
  if (m.includes("timeout") || m.includes("timed out") || m.includes("longer than expected")) {
    return "Processing took too long — try again";
  }
  if (m.includes("network") || m.includes("connection") || m.includes("offline")) {
    return "Connection problem — check your network";
  }
  if (m.includes("unreadable") || m.includes("corrupt") || m.includes("clearer")) {
    return "File couldn't be read — try a clearer image";
  }

  return null;
};

export const humanizeUploadFailure = (errorType, errorMessage) => {
  const typeKey = (errorType || "").trim().toUpperCase();
  if (TYPE_LABELS[typeKey]) return TYPE_LABELS[typeKey];
  const fromMsg = messageHeuristic(errorMessage);
  if (fromMsg) return fromMsg;
  return "Couldn't process this floor plan";
};
